define('views/product/index',[],function () {
	'use strict';

	require(['classes/socialbutton'], function (SocialButton) {
		var socialButtons = document.querySelectorAll('#share-buttons a'),
			i;
		for (i = 0; i < socialButtons.length; ++i) {
			new SocialButton({
				element: socialButtons[i],
				type: socialButtons[i].getAttribute('data-share-type')
			}).initiate();
		}
	});

	window.assets = window.assets || {};

	require(['classes/packshot'], function (packshot) {
		window.assets.packshot = packshot;
		window.assets.packshot.initiate(function () {
			console.log('packshot initiated the old way');
		});
	});

	require(['classes/lazyload'], function (LazyLoad) {
		window.assets.lazyload = new LazyLoad().initiate();
	});
	require(['swiper'], function (model) {
		var swiper = new Swiper(".mySwiper", {
			slidesPerView: "auto",
			centeredSlides: true,
			spaceBetween: 30,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
		var galleryTop = new Swiper('.gallery-top', {
			pagination: '.swiper-pagination',
			paginationClickable: true,
			zoom: false,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			paginationBulletRender: function (swiper, index, className) {
				return '<span class="' + className + '"></span>';
			},
		});
		galleryTop.on('onSlideChangeStart', function (sw) {
			for (var j = 0; j < sw.slides.length; j++) {
				var vid = $(sw.slides[j]).children("a").children("video")[0];
					if (vid) {
						vid.pause();
						console.log('paused vid')
					}
					var elm = document.getElementById('thumb_' + j);
					if (j == sw.activeIndex) {
						$(elm).addClass('selected');
					} else {
						$(elm).removeClass('selected');
					}
			}
		});
		galleryTop.on('onSlideChangeEnd', function (sw) {
			var sl = sw.slides[sw.activeIndex];
			if ($(sl).hasClass('gallery-top-video-slide')) {
				const vid = $(sl).children("a").children("video")[0];
				vid.play();
				console.log('started vid');
			}
		});
	});
		//galleryTop.on('onSlideChangeStart', function (sw) {
		//	for (var j = 0; j < sw.slides.length; j++) {
		//		var elm = document.getElementById('thumb_' + j);
		//		if (j == sw.activeIndex) {
		//			$(elm).addClass('selected');
		//		} else {
		//			$(elm).removeClass('selected');
		//		}
		//	}
		//});
		//galleryTop.on('onSlideChangeEnd', function (sw) {
		//});

	/*require(['classes/recommendations'], function(recommendations) {
		window.assets.recommendations = recommendations;
		window.assets.recommendations.initiate(function() {
			console.log('recommendations initiated the old way');
		});
	});*/
	require(['classes/recommendation', 'postal'], function(Recommendation, postal) {
		var recommendations = document.querySelectorAll('.recommendations'),
			i,
			recommendationsObjects = [];
		for (i = 0; i < recommendations.length; ++i) {
			recommendationsObjects.push(new Recommendation({
				element: recommendations[i],
				type: recommendations[i].getAttribute('data-recommendation-type')
			}).initiate());
		}

		var isRecommendationsReady = function() {
			for (i = 0; i < recommendations.length; ++i) {
				if (!recommendationsObjects[i].ready) {
					return false;
				}
			}

			clearInterval(waitForAllRecommendations);

			return true;
		};

		var waitForAllRecommendations = setInterval(function() {
			if (isRecommendationsReady()) {
				postal.channel('nosto').publish({
					topic: 'recommendation.all',
					data: function () {

					    postal.channel('recommendation').publish({
					        topic: 'render'
					    });
					    if (window.assets.voucher) {
					        window.assets.voucher.addPrices();
					    }
					}

				});
			}
		}, 200);
		
	});

	/*require(['classes/productcollection'], function(collection) {
		window.assets.collection = collection;
		window.assets.collection.initiate(function() {
			console.log('collection initiated the old way');
		});
	});

	require(['classes/swipeband'], function(swipeBand) {
		window.assets.swipeBand = swipeBand;
		window.assets.swipeBand.initiate(function() {
			console.log('swipeBand initiated the old way');
		});
	});*/

	/*require(['classes/productdetails'], function(productDetails) {
		window.assets.productDetails = productDetails;
		window.assets.productDetails.initiate(function() {
			console.log('productDetails initiated the old way');
		});
	});*/

	require(['classes/productbuttons'], function(ProductButtons) {
		new ProductButtons({
			element: document.querySelector('#specifications div.controls')
		}).initiate();
	});

	require(['classes/arrows'], function(Arrows) {
		new Arrows({
			element: document.querySelector('#arrows')
		}).initiate();
	});


	require(['classes/images'], function(images) {
		window.assets.images = images;
		window.assets.images.initiate(function() {
			console.log('images initiated the old way');
		});
	});

	/*require(['classes/social'], function(social) {
		window.assets.social = social;
		window.assets.social.initiate(function() {
			console.log('social initiated the old way');
		});
	});*/

	require(['classes/backbutton'], function(backButton) {
		window.assets.backButton = backButton;
		window.assets.backButton.initiate(function() {
			console.log('backButton initiated the old way');
		});
	});

	require(['classes/modal'], function(modal) {
		window.assets.modal = modal;
		window.assets.modal.initiate(function() {
			console.log('modal initiated the old way');
		});
	});

	/*window.assets.packshot = require('classes/packshot');
	window.assets.packshot.initiate(function() {
		console.log('packshot initiated the old way');
	});

	window.assets.images = require('classes/images');
	window.assets.images.initiate(function() {
		console.log('images initiated the old way');
	});

	window.assets.social = require('classes/social');
	window.assets.social.initiate(function() {
		console.log('social initiated the old way');
	});

	window.assets.productDetails = require('classes/productdetails');
	window.assets.productDetails.initiate(function() {
		console.log('productDetails initiated the old way');
	});

	window.assets.backButton = require('classes/backbutton');
	window.assets.backButton.initiate(function() {
		console.log('backButton initiated the old way');
	});

	window.assets.modal = require('classes/modal');
	window.assets.modal.initiate(function() {
		console.log('modal initiated the old way');
	});
	*/
});
